<ng-container [formGroup]="formGroupCampaignTypeData">
    <div class="row">
        <div class="col-12">
            <app-mdb-switch label="Don't allow donors to set amount less than option amount." formControlName="dontAllowAmountReduction"></app-mdb-switch>
            <div class="divider"></div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <app-mdb-switch label="Capture Naam/Gotra information" formControlName="sankalpDataNeeded"></app-mdb-switch>
            <div data-panel="settings" class="w-100" style="padding-left: 44px;" formGroupName="sankalpDataDisplay" *ngIf="formGroupCampaignTypeData.value.sankalpDataNeeded">
                <div class="row">
                    <div class="col-4">
                        <mdb-form-control class="form-fill" data-panel="settings">
                            <app-mdbp-input mdbInput formControlName="nakshtraDisplay"  data-panel="settings" label='Nakshtra'></app-mdbp-input>
                        </mdb-form-control>
                    </div>
                    <div class="col-4">
                        <mdb-form-control class="form-fill" data-panel="settings">
                            <app-mdbp-input mdbInput formControlName="gotraDisplay" data-panel="settings" label='Gotra'></app-mdbp-input>
                        </mdb-form-control>
                    </div>
                    <div class="col-4">
                        <mdb-form-control class="form-fill" data-panel="settings">
                            <app-mdbp-input mdbInput formControlName="rasiDisplay" data-panel="settings" label='Rashi'></app-mdbp-input>
                        </mdb-form-control>
                    </div>
                </div>
            </div>
            <div class="divider"></div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <ng-container *ngIf="selectHinduTempleLocations$ | async as selectHinduTempleLocations">
                <mdb-form-control class="form-fill">
                    <mdb-select formControlName="campaignLocationId" class="mdb-select" data-panel="settings">
                      <mdb-option *ngFor="let selectHinduTempleLocation of selectHinduTempleLocations" [value]="selectHinduTempleLocation._id">
                        {{selectHinduTempleLocation.city}}, {{selectHinduTempleLocation.state}}
                      </mdb-option>
                    </mdb-select>
                    <label mdbLabel class="form-label form-label--paybee">Select temple locaton</label>
                    <mdb-error class="form-fill-error" *ngIf="formGroupCampaignTypeData.controls.campaignLocation.hasError('required') && formGroupCampaignTypeData.controls.campaignLocation.touched">Please provide Hindu Temple Location</mdb-error>
                  </mdb-form-control>
            </ng-container>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <mdb-form-control class="form-fill">
                <mdb-select formControlName="timeZone" class="mdb-select">
                  <mdb-option *ngFor="let timeZone of timeZoneList" [value]="timeZone.value">
                    {{timeZone.label}}
                  </mdb-option>
                </mdb-select>
                <label mdbLabel class="form-label form-label--paybee">Select temple time zone</label>
                <mdb-error class="form-fill-error" *ngIf="formGroupCampaignTypeData.controls.timeZone.hasError('required') && formGroupCampaignTypeData.controls.timeZone.touched">Please provide Hindu Temple Time Zone</mdb-error>
              </mdb-form-control>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <p class="mb-0 grey-text small"> Type a option and press enter to add. Click <strong>X</strong> to remove it. </p>
            <app-chips 
            placeholder="Press Enter to add each Deity" 
            formControlName="deityList"
            [touched]="deityList.touched"
            [required]="false"
            idChips="deityList"
       ></app-chips>
        </div>
    </div>
</ng-container>